import { useMemo } from "react";
import { useNodeMetrics } from "hooks/useMetrics";
import MetricsExtractor from "logic/metrics/MetricsExtractor";
const metricNames = {
  segments: "org.graylog.plugins.datalake.output.journal.numberOfSegments",
  messageUncommitted: "org.graylog.plugins.datalake.output.journal.uncommittedMessages",
  unflushedMessages: "org.graylog.plugins.datalake.output.journal.unflushedMessages",
  oldestSegment: "org.graylog.plugins.datalake.output.journal.oldest-segment",
  writtenMessage: "org.graylog.plugins.datalake.output.journal.writtenMessages",
  size: "org.graylog.plugins.datalake.output.journal.size"
};
const metricValues = Object.values(metricNames);
const useDataLakeJournalMetrics = (nodeId) => {
  const { data: nodeMetrics } = useNodeMetrics(nodeId, metricValues);
  return useMemo(
    () => MetricsExtractor.getValuesForNode(nodeMetrics, metricNames),
    [nodeMetrics]
  );
};
export default useDataLakeJournalMetrics;
